module.exports = __webpack_public_path__ + "img/icon_acc_profile.e32a1799.svg";